export enum DepositStatus {
	All = 'All',
	Open = 'Open',
	Closed = 'Closed',
	Cleared = 'Cleared',
	Voided = 'Voided',
}
